import { render, staticRenderFns } from "./produtoassociacao.vue?vue&type=template&id=bf34da1e"
import script from "./produtoassociacao.ts?vue&type=script&lang=js&external"
export * from "./produtoassociacao.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf34da1e')) {
      api.createRecord('bf34da1e', component.options)
    } else {
      api.reload('bf34da1e', component.options)
    }
    module.hot.accept("./produtoassociacao.vue?vue&type=template&id=bf34da1e", function () {
      api.rerender('bf34da1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/importacaonfe/produtoassociacao.vue"
export default component.exports